export const passwordRules = [
  { key: 'length', label: 'At least 10 characters', test: password => password.length >= 10 },
  { key: 'uppercase', label: 'At least one uppercase letter', test: password => /[A-Z]/.test(password) },
  { key: 'lowercase', label: 'At least one lowercase letter', test: password => /[a-z]/.test(password) },
  { key: 'number', label: 'At least one number', test: password => /\d/.test(password) },
  { key: 'special', label: 'At least one special character', test: password => /[^A-Za-z0-9\s]/.test(password) },
  { key: 'spaces', label: 'No spaces', test: password => !/\s/.test(password) },
];

export function getPasswordValidation(password) {
  return passwordRules.map(rule => ({ ...rule, valid: rule.test(password) }));
}

export function isValidPassword(password) {
  return getPasswordValidation(password).every(rule => rule.valid);
}

export function PasswordRequirements({ password }) {
  return (
    <ul className="small ps-3 mb-3" aria-label="Password requirements">
      {getPasswordValidation(password).map(rule => (
        <li key={rule.key} className={rule.valid ? 'text-success' : 'text-muted'}>
          {rule.valid ? '✓' : '○'} {rule.label}
        </li>
      ))}
    </ul>
  );
}
